import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { KgSecondarySidebar } from "./KgSecondarySidebar";
import type { KgSidebarSection } from "./KgSecondarySidebar.types";
import { useLayout } from "../../../context/LayoutContext";
import {
  buildKgSidebarPath,
  resolveKgSidebarSectionFromPath,
} from "../../../services/kg/kgSidebarNavigation";

/**
 * URL-driven wrapper around <KgSecondarySidebar>.
 *
 * Layout rules:
 * - KG page loads: main sidebar is hidden (LayoutContext), secondary starts collapsed.
 * - Expand button: secondary expands AND main sidebar (icon-only) appears together.
 * - Collapse button: secondary collapses AND main sidebar hides together.
 *
 * The expand/collapse toggle drives both sidebars in sync via toggleSidebar().
 */
export const KgSecondarySidebarConnected: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { toggleSidebar } = useLayout();
  const [isCollapsed, setIsCollapsed] = useState(true);

  const activeSection = resolveKgSidebarSectionFromPath(location.pathname);

  const handleToggle = () => {
    setIsCollapsed((v) => !v);
    toggleSidebar();
  };

  return (
    <KgSecondarySidebar
      activeSection={activeSection}
      onSectionChange={(section: KgSidebarSection) =>
        navigate(buildKgSidebarPath(section))
      }
      isCollapsed={isCollapsed}
      onCollapseToggle={handleToggle}
    />
  );
};

export default KgSecondarySidebarConnected;
